import { TextOrHTML } from "@simplybusiness/mobius";
import type { SmallPrint as SmallPrintType } from "./types";

export type SmallPrintProps = {
  text: SmallPrintType;
};

export const SmallPrint = (props: SmallPrintProps) => {
  const { text } = props;

  if (!text) {
    console.warn("SmallPrint will not render. Prop text is empty.");
    return null;
  }

  return (
    <TextOrHTML
      variant="legal"
      className="mobius-footer__small-print"
      text={text}
      textWrapper
    />
  );
};
